import { Box } from "@mui/material";
import {
	DateField,
	Show,
	SimpleShowLayout,
	TextField,
	useRecordContext,
} from "react-admin";

const StatusChip = () => {
	const record = useRecordContext();
	if (!record) return null;

	const colors: Record<string, string> = {
		accrued: "#2196f3",
		processing: "#ff9800",
		unpayable: "#9e9e9e",
		void: "#f44336",
		paid: "#4caf50",
	};

	return (
		<Box
			sx={{
				display: "inline-block",
				px: 1,
				py: 0.5,
				borderRadius: 1,
				backgroundColor: colors[record.status] || "#757575",
				color: "white",
				fontSize: "0.75rem",
				fontWeight: 500,
				textTransform: "uppercase",
			}}
		>
			{record.status}
		</Box>
	);
};

const AmountField = () => {
	const record = useRecordContext();
	if (!record) return null;
	return <span>${(record.amountCentsUSD / 100).toFixed(2)} USD</span>;
};

export const PartnerEarningShow = () => (
	<Show>
		<SimpleShowLayout>
			<TextField source="id" label="ID" />
			<StatusChip />
			<AmountField />
			<TextField source="appId" label="App ID" />
			<TextField source="partnerId" label="Partner ID" />
			<TextField source="installId" label="Install ID" />
			<TextField source="transactionId" label="Transaction ID" />
			<TextField source="payoutId" label="Payout ID" emptyText="-" />
			<DateField source="periodStart" label="Period Start" emptyText="-" />
			<DateField source="periodEnd" label="Period End" emptyText="-" />
			<DateField source="createdAt" label="Created At" showTime />
		</SimpleShowLayout>
	</Show>
);
